import { styled } from 'stitches.config'
import { Icon } from 'components/Icon'

export const SelectRecipeRoot = styled('section', {
  backgroundColor: '$accent-white',
  padding: '$5 $3',
  '@bp2': {
    padding: '$9 $4',
  },
})

export const SelectRecipeWrapper = styled('div', {
  maxWidth: '1200px',
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  gap: '$3',
  '@bp2': {
    gap: '$5',
  },
})

export const Header = styled('h2', {
  fontSize: '$h4',
  fontWeight: '$extraLight',
  textAlign: 'center',
  lineHeight: '$h2',
  '@bp2': {
    fontSize: '$h3',
  },
})

export const PointsList = styled('ul', {
  listStyle: 'none',
  padding: 0,
  margin: 0,
  gap: '$2',
  display: 'flex',
  flexDirection: 'column',
  '@bp2': {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
})

export const PointsListItem = styled('li', {
  listStyle: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: '$2',
})

export const CheckIcon = styled(Icon, {
  width: '11px',
  height: '16px',
  border: '1px solid $primary-500',
  borderRadius: '$round',
  padding: '2px',
  color: '$primary-500',
  fill: '$primary-500',
})

export const ProteinName = styled('h3', {
  fontSize: '$h3',
  fontWeight: '$extraLight',
  lineHeight: '36px',
})

export const ProductListContainer = styled('ul', {
  listStyle: 'none',
  padding: 0,
  margin: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: '$3',
  '@bp1_1': {
    flexDirection: 'row',
  },
  variants: {
    type: {
      'freeze-dried': {
        '@bp2': {
          gap: '80px',
        },
      },
    },
  },
})

export const ProductListItem = styled('li', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  width: '100%',
  border: '1px solid $accent-gray',
  borderRadius: '$1',
  gap: '20px',
  padding: '$2 20px',
  '@bp1_1': {
    padding: '$4 20px',
    width: '48%',
  },
  '@bp2': {
    width: '31%',
  },
  variants: {
    type: {
      'freeze-dried': {
        flexDirection: 'row',
        alignItems: 'center',
        '@bp2': {
          minWidth: '417px',
        },
      },
    },
  },
})

export const ImageWrapper = styled('div', {
  minWidth: '93px',
  minHeight: '130px',
  variants: {
    type: {
      'freeze-dried': {
        minWidth: '115px',
        minHeight: '175px',
        '@bp1_1': {
          minWidth: '150px',
          minHeight: '210px',
        },
      },
    },
  },
})

export const ButtonBox = styled('div', {
  alignSelf: 'center',
})
